import { Fragment } from 'react'

import { ChevronRight } from 'lucide-react'

import { Button } from '~/components/component-library'
import { StepIndex } from '~/hooks/useSmartAccountSetupStep'

export const Breadcrumb = ({
  step,
  setStep,
  availableStep,
  isSavingFinalStep,
  index,
  label,
}: {
  step: StepIndex
  setStep: (step: StepIndex) => void
  availableStep: number
  isSavingFinalStep: boolean
  index: number
  label: string
}) => {
  return (
    <Fragment key={index}>
      {index > 0 && <ChevronRight className="h-4 text-secondary" />}
      <Button
        variant="tertiary"
        size="small"
        isSelected={step === index}
        aria-current={step === index ? 'step' : undefined}
        isDisabled={
          (availableStep < index && step !== index) || isSavingFinalStep
        }
        onClick={() => {
          setStep(index as StepIndex)
        }}
      >
        {label}
      </Button>
    </Fragment>
  )
}
